import { Directive } from '@angular/core';

@Directive({
  selector: '[treeLeafNodeDef]'
})
export class TreeLeafNodeDefDirective {}
